<template>
    <div>
    <div v-if="error">
        <app-message :rang="rang"  :matn="error_message" ></app-message>
    </div>

    <v-dialog  v-model="qurbnoma_dialog"  max-width="200" v-if="loading"
            persistent>
            <v-card>
              <v-card-title class="headline text-strong">Загрузка</v-card-title>
              <v-card-text>
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
        </v-dialog>

    <v-dialog v-if="!loading"
    v-model="qurbnoma_dialog"
    max-width="350"
    persistent
  >
    <v-card>
      <v-form @submit.prevent="qurb_save"

                  ref="qurb_list"
                  v-model="valid_qurb"

              >
      <v-card-title class="text-h5">
       Выберите курс валюты
      </v-card-title>

      <v-card-text >
          <v-text-field
          clearable
          v-model="qurb_list.usd"
          label="USD"
          prepend-icon="mdi-currency-usd"
          :rules="currencyRules"
        ></v-text-field>

        <v-text-field
        clearable
        v-model="qurb_list.rub"
        label="RUB"
        prepend-icon="mdi-currency-rub"
        :rules="currencyRules"
      ></v-text-field>
      <v-btn
      color="primary darken-1"
      block
      dark
      :disabled="!valid_qurb"
      type="submit"
      :loading="loading"
    >
      Применить
    </v-btn>
      </v-card-text>
  </v-form>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
export default {
    data () {
    return {
        loading: false,
        error: false,
            error_message: '',
            rang: '#D50000',
            valid_qurb: false,
            qurbnoma_dialog: true,

            qurb_list: {
                usd: '',
                rub: '',
                id_user:''
            },

            currencyRules:[
            v => !!v || 'Введите курс валюты',
            v=> (v && /[0-9]/.test(v)) || 'Неверный формат ввода',
            v => (v && /^\d*\.?\d*$/.test(v)) || 'Неверный формат ввода',


      ],

    }
},
mounted() {
    this.get_qurbs();

},
methods:{
    get_qurbs(){
        this.loading = true;
        this.qurbnoma_dialog = true;
        axios.get('/api/get_qurbs', {
                headers: {
                    "Content-type": "application/json"
                }
            })
            .then(response => {
                    if(response.data.status){
                        this.loading = false;
                        this.qurb_list.usd = response.data.usd;
                        this.qurb_list.rub = response.data.rub;
                        this.rang = '#4CAF50';
                        this.$session.start();
                        this.qurb_list.id_user = this.$session.get('id_user');

                    }else{
                        this.loading = false;
                        this.error = true;
                        this.error_message = "Ошибка получение курсов валют";
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                    }

                })
                .catch(error => {
                    this.loading  = false;
                    this.error = true;
                    this.error_message = error.response.data.message;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);
                });

    },

    qurb_save(){
    this.loading = true;

        //session start
        this.$session.start();
        if(this.$session.get('dostup')=='1'){

            axios.post('/api/qurb_save', this.qurb_list, {
                headers: {
                    "Content-type": "application/json"
                }
            })

                .then(response => {
                    if(response.data.status){
                        this.loading = false;
                        this.rang = '#4CAF50';
                        this.error = true;
                        this.error_message = "Курсы валют успешно обновлены!";
                        this.qurbnoma_dialog = false;






                        setTimeout(() => {
                            this.error = false;
                        }, 2000);


                    }else{
                        this.loading = false;
                        this.error = true;
                        this.error_message = "Ошибка сохранения курсов валют";
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);



                    }

                })
                .catch(error => {
                    this.loading = false;
                    this.rang = '#D50000';
                    this.error = true;
                    this.error_message = error.response.data.message;
                    this.qurbnoma_dialog = false;
                        setTimeout(() => {
                            this.error = false;
                        }, 2000);

                });

        }else{
            this.loading = false;
            this.error = true;
            this.error_message = "У вас нет доступа к этой функции";
            setTimeout(() => {
                this.error = false;
            }, 2000);
            this.qurbnoma_dialog = false;

        }

            this.$session.start();
            this.$session.set('usd', this.qurb_list.usd);
            this.$session.set('rub', this.qurb_list.rub);
            this.$emit('qurb_change');




},
}
}
</script>

<style>

</style>





